import React from "react";
import { useTranslation } from "react-i18next";
import { generatePath, useParams, useSearchParams } from "react-router-dom";

import { Text } from "@chakra-ui/react";

import StripeCheckoutWidget from "components/StripeCheckoutWidget";
import { PAGE_PATHS } from "config/routes";
import { usePreferencesStore } from "stores/preferences";
import { PRODUCTS_NAME } from "types/products";
type IParams = {
  token: string;
};

const CheckoutView = () => {
  const { t } = useTranslation();
  const currency = usePreferencesStore((store) => store.currency);
  const { token } = useParams<IParams>();
  const [searchParams] = useSearchParams();

  const baseCallbackUrl = generatePath(PAGE_PATHS.UPSELL.TRIPS.PROCESSING_PAYMENT_PAGE, {
    token: token?.toString() || "",
  });

  const callbackUrl = new URL(baseCallbackUrl, window.location.origin);

  callbackUrl.search = searchParams.toString();

  return (
    <>
      <Text fontSize="lg" fontWeight="medium" mb={5} data-testid="card-details">
        {t("payment.checkout.payment_method")}
      </Text>
      <StripeCheckoutWidget
        key={currency}
        productName={PRODUCTS_NAME.UPGRADE_TO_TRIP_COMPLETE}
        callbackUrl={callbackUrl.toString()}
        tripUuid={token}
      />
    </>
  );
};

export default CheckoutView;
